import { createApi } from '@reduxjs/toolkit/query/react'

import { urlDetallePax, urlResumenDia } from './urlDetallePax'

import { DashboardOperativoDiaData, DetallePaxData, DetallePaxParams } from '../interfaces/dashboardOperativoDia'

import { baseQuery } from '@/core/api/baseQuery'
import { unwrapPreserve } from '@/core/api/unwrapPreserve'

export const dashboardOperativoDiaApi = createApi({
  reducerPath: 'dashboardOperativoDiaApi',
  baseQuery,
  endpoints: (builder) => ({
    getResumenDia: builder.query<DashboardOperativoDiaData, { fecha: string; version?: number }>({
      // `version` solo existe para el botón de actualizar: el backend cachea el resumen 60 s por
      // query string completa, así que un parámetro distinto trae datos frescos en vez de la
      // entrada guardada. Sin él (carga normal, cambio de fecha) la URL es la de siempre.
      query: ({ fecha, version }) => ({
        url: urlResumenDia(fecha, version),
        method: 'GET',
      }),
      transformResponse: (response: unknown) => unwrapPreserve(response) as DashboardOperativoDiaData,
    }),
    getDetallePax: builder.query<DetallePaxData, DetallePaxParams>({
      query: (params) => ({
        url: urlDetallePax(params),
        method: 'GET',
      }),
      transformResponse: (response: unknown) => unwrapPreserve(response) as DetallePaxData,
    }),
  }),
})

export const { useGetResumenDiaQuery, useLazyGetResumenDiaQuery, useGetDetallePaxQuery } = dashboardOperativoDiaApi
